/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

export const accessTokenTypes = {
  FORGOT_PASSWORD: 'forgot_password',
  CHANGE_EMAIL: 'change_email',
  AUTHENTICATE: 'authenticate',
  MFA: 'mfa',
  EXPIRED: 'EXPIRED',
};

export const sessionDurationTypes = {
  SHORT: 'short',
  LONG: 'long',
};

class AccessTokenModel {

  static extractDataFromAuthToken(token) {
    const tokenParts = token.split('.');
    return tokenParts[1] ? JSON.parse(window.atob(tokenParts[1])) : {};
  }

  static createFromAuthToken(token) {
    const data = AccessTokenModel.extractDataFromAuthToken(token);
    return new AccessTokenModel(data);
  }

  constructor(data) {
    this.data = _.assign({}, {
      user: {},
    }, data);
  }

  userId() {
    return this.data.user.id;
  }

  tokenType() {
    return this.data.type;
  }

  getMillisecsUntilRefresh() {
    const refreshInMillisecs = this.data.exp * 1000;
    return refreshInMillisecs - new Date().getTime();
  }

  getMillisecsDuration() {
    return Math.max(this.data.exp - this.data.iat, 1) * 1000;
  }

  requiresMfa() {
    return this.data.type === accessTokenTypes.MFA;
  }

  isLoggedIn() {
    return this.data.type === accessTokenTypes.AUTHENTICATE;
  }

  userData() {
    return this.data.user;
  }

  isTrusted() {
    return this.data.duration === sessionDurationTypes.LONG;
  }
}

export default AccessTokenModel;
